// extracted by mini-css-extract-plugin
export default {"scrollFadeContainer":"scrollFadeContainer-Xr8iFgTx","fadeTop":"fadeTop-Dz8dcnFU","fadeBottom":"fadeBottom-hZCPDIH0"};